import React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';

type FormViewProps = {
  children: React.ReactNode;
  styles?: StyleProp<ViewStyle> | undefined;
};
const FormView = ({children, styles}: FormViewProps) => (
  <View style={[internalStyles.main, styles]}>{children}</View>
);

const internalStyles = StyleSheet.create({
  main: {
    flex: 1,
    backgroundColor: 'white',
    paddingVertical: 24,
    paddingHorizontal: 16,
    alignItems: 'stretch',
    justifyContent: 'space-between',
    zIndex: 50,
  },
});

export default FormView;
